export default __webpack_public_path__ + "src/images/galleries/1/shadow_bg-513c7c.png";